import PropTypes from "prop-types";
import axios from "axios";

import BaseAddProductModal from "../../../../components/modal/BaseAddProductModal";

class CollectionAddProductModal extends BaseAddProductModal {
    abstractGetTitle() {
        return "Product toevoegen"
    }

    // eslint-disable-next-line no-unused-vars
    abstractSave(productId, onComplete, onError) {
        axios.post("/addProductToCollection", {
            shopId: this.context.currentShop.id,
            collectionId: this.props.collection.id,
            productId
        })
            .then((response) => {
                if(response.data.valid) {
                    this.props.setCollection(response.data.collection);
                    onComplete();
                } else {
                    onError("Er ging iets fout bij het toevoegen van het product. (" + response.data.error + ")");
                }
            })
            .catch((error) => {
                console.error(error);
                onError("Er ging iets fout bij het toevoegen van het product.");
            });
    }
}
CollectionAddProductModal.propTypes = {
    ...BaseAddProductModal.propTypes,
    collection: PropTypes.object.isRequired,
    setCollection: PropTypes.func.isRequired
}

export default CollectionAddProductModal;
